module.exports = __webpack_public_path__ + "media/src/images/logos/pipedrive-8474e65c8f976e2c75779def5347a0f7.png";